import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import React from 'react'

export const Placeholder = () => (
  <div className='ui fluid placeholder'>
    <div className='header'>
      <div className='line' />
      <div className='line' />
    </div>
    <div className='paragraph'>
      <div className='line' />
      <div className='line' />
      <div className='line' />
    </div>

    <div className='paragraph'>
      <div className='line' />
      <div className='line' />
      <div className='line' />
      <div className='line' />
      <div className='line' />
    </div>

    <div className='paragraph'>
      <div className='line' />
      <div className='line' />
    </div>
  </div>
)
